// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.name {
    font-size: 14px;
    font-weight: 500;
    color: #353f4a;
    margin: 0;
    }
.file-list {
    width: 90%;
    display: flex;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    border-radius: 10px;
    padding: 5px
    }
.info {
    width: 100%
    }

quill-editor {
  display: block;
  height: 100%;
}

.ql-container {
  height: calc(100% - 42px);
  overflow-y: auto;
}

.ql-editor {
  overflow-y: auto;
}

/*Remove the functionality where the row is shaded around it.
*/
.no-hover tr:hover {
  background-color: transparent !important;
}

tr:hover {
    box-shadow: none;
    outline: none;
    background-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/app/compose-email/compose-email.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT;AACJ;IACI,UAAU;IACV,aAAa;IACb,iDAAiD;IACjD,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB;IACA;AACJ;IACI;IACA;;AAEJ;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;CACC;AACD;EACE,wCAAwC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,wCAAwC;AAC5C","sourcesContent":[".name {\n    font-size: 14px;\n    font-weight: 500;\n    color: #353f4a;\n    margin: 0;\n    }\n.file-list {\n    width: 90%;\n    display: flex;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    margin-top: 15px;\n    border-radius: 10px;\n    padding: 5px\n    }\n.info {\n    width: 100%\n    }\n\nquill-editor {\n  display: block;\n  height: 100%;\n}\n\n.ql-container {\n  height: calc(100% - 42px);\n  overflow-y: auto;\n}\n\n.ql-editor {\n  overflow-y: auto;\n}\n\n/*Remove the functionality where the row is shaded around it.\n*/\n.no-hover tr:hover {\n  background-color: transparent !important;\n}\n\ntr:hover {\n    box-shadow: none;\n    outline: none;\n    background-color: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
